<template>
    <section>
        <b-loading :active.sync="isLoading"></b-loading>

        <div class="columns">
 
            <div class="column is-3">
                <div  class="panel">
                    <p class="panel-heading background-2  cp" @click="orderAstecsAbertura==2 ? orderAstecsAbertura= 0 : orderAstecsAbertura++; ordenar('astecsAbertura')">                  
                        <span><b-icon :icon="iconeorderAstecsAbertura"  size="is-small"> </b-icon></span>
                        {{$t('ASTECS.ABERTURA')}} 
                        
                        ({{ listaAstecsAbertura.length}})
                        <span v-if="listaAstecsAbertura.filter(x=>x.atraso).length>0" class="ml-1 tag is-danger blink_me" title="Prazo vencido">{{ listaAstecsAbertura.filter(x=>x.atraso).length }}</span>                          

                        <span class="is-pulled-right ">
                            <b-button v-if="isInRole('astecs-abertura')"  class="is-info" size="is-small" 
                            :title="$t('ASTECS.NOVAASTEC')" icon-left="account-plus"
                            @click="inserirNovaAstec()"></b-button>                                                                                                            
                        </span>                          
                    </p>

                        <router-link   :to="{ name: 'guia-astec-list', query: { tipo:'todos' }  }" class="button is-link is-outlined is-fullwidth">
                            {{$t('ASTECS.LISTARTODOS')}}                             
                        </router-link>                         
                    <table class="table is-fullwidth is-striped is-hoverable">     
                        <tbody>
                            <tr :class="retornaEstiloLinha(item)" v-for="(item, index) in listaAstecsAbertura" v-bind:key="index">
                                
                                <td>
                                    <span>{{item.clienteCodigoExterno}} </span>  
                                    <span   class="cp" @click="abrirGuia(item.guiaId)">
                                        <b-icon v-if="item.guiaId > 0"  icon="link"
                                                        size="is-small"                                    
                                                        :title="$t('GUIALIST.ATENDIMENTOVINCULADO')"
                                                        type="is-link"></b-icon>                                        

                                    </span>
                                    <b-icon v-if="item.dataHoraAgendamentoAstec"
                                                        icon="calendar"
                                                        size="is-small"
                                                        type="is-info"                                    
                                                        :title="$t('VENDAS.AGENDAMENTOENTREGAREALIZADO')"></b-icon>                                      
                                                                        
                                </td>                                
                                <td class="pl-0 pr-0">
                                    <b-tooltip  size="is-small" position="is-top" type="is-light"  > 
                                        <template v-slot:content>                                           
                                            <span v-if="item.dataHoraAgendamentoAstec">       
                                                <b>DATA PARA VISITA: </b>  {{$moment(item.dataHoraAgendamentoAstec).format('DD/MM/YYYY')}}                                                
                                            </span>                                                                                                                                                            
                                        </template>                                             
                                        <span class="is-size-7 highlight">{{item.clienteNome}} </span>
                                    </b-tooltip>  
                                </td>                                
                                <td>
                                    <div class="is-inline-flex">
                                        <router-link v-if="isInRole('astecs-abertura')" :to="{ name: 'guia-astec', params: { id: item.id}}" class="button is-small is-primary" title="Abrir Astec">
                                            <b-icon icon="pencil" size="is-small"></b-icon>
                                        </router-link> 
                                        <b-button  class="is-small"  @click="confirmarInclusaoObservacao( item.id)" 
                                        :title="$t('ASTECS.INCLUIROBSERVACAO')" icon-left="comment"></b-button>                                                                                                                                                                          
                                    </div>                                                                              
                                </td>                                
                            </tr>  
                        </tbody>                                                 
                    </table>
                    
                </div>
            </div>


            <div class="column is-3">
                <div  class="panel">
                    <p class="panel-heading background-2  cp" @click="orderAstecsVisita==2 ? orderAstecsVisita= 0 : orderAstecsVisita++; ordenar('astecsVisita')">                  
                        <span><b-icon :icon="iconeorderAstecsVisita"  size="is-small"> </b-icon></span>                                        
                        {{$t('ASTECS.CONCLUSAOVISITA')}} 
                        ({{ listaAstecsVisita.length}})
                        <span v-if="listaAstecsVisita.filter(x=>x.atraso).length>0" class="ml-1 tag is-danger blink_me" title="Prazo vencido">{{ listaAstecsVisita.filter(x=>x.atraso).length }}</span>                          
                    </p>
                    <router-link  :to="{ name: 'agenda', query:{tipo: 5,filtrarTodos:true}, params: {voltarTela: 'astecs' } }" class="button is-link is-outlined is-fullwidth">
                            {{$t('ATENDIMENTO.ABRIRCALENDARIO')}}
                    </router-link>                        
                    

                    <table class="table is-fullwidth is-striped is-hoverable">     
                        <tbody>
                            <tr :class="retornaEstiloLinha(item)" v-for="(item, index) in listaAstecsVisita" v-bind:key="index">
                                
                                <td>
                                    <span>{{item.clienteCodigoExterno}} </span>
                                    <span   class="cp" @click="abrirGuia(item.guiaId)">
                                        <b-icon v-if="item.guiaId > 0"  icon="link"
                                                        size="is-small"                                    
                                                        :title="$t('GUIALIST.ATENDIMENTOVINCULADO')"
                                                        type="is-link"></b-icon>    
                                    <b-icon v-if="item.dataHoraAgendamentoAstec"
                                                        icon="calendar"
                                                        size="is-small"
                                                        type="is-info"                                    
                                                        :title="$t('VENDAS.AGENDAMENTOENTREGAREALIZADO')"></b-icon>                                                                                                  

                                    </span>                        
                                </td>                                
                                <td class="pl-0 pr-0">
                                    <b-tooltip  size="is-small" position="is-top" type="is-light"  > 
                                        <template v-slot:content>                                           
                                            <span v-if="item.dataHoraAgendamentoAstec">       
                                                <b>DATA PARA VISITA: </b>  {{$moment(item.dataHoraAgendamentoAstec).format('DD/MM/YYYY')}}                                                
                                            </span>                                                                                                                                                            
                                        </template>                                             
                                        <span class="is-size-7 highlight">{{item.clienteNome}} </span>
                                    </b-tooltip>  
                                </td>                                
                                <td>
                                    <div class="is-inline-flex">
                                        <router-link v-if="isInRole('astecs-conclusaovisita')" :to="{ name: 'guia-astec', params: { id: item.id, paraAnaliseVisita:true}}" class="button is-small is-primary" title="Abrir Astec">
                                            <b-icon icon="pencil" size="is-small"></b-icon>
                                        </router-link> 
                                        <b-button  class="is-small"  @click="confirmarInclusaoObservacao( item.id)" 
                                        :title="$t('ASTECS.INCLUIROBSERVACAO')" icon-left="comment"></b-button>                                                                                                                                                                          
                                    </div>                                          
                                    
                                </td>                                
                            </tr>  
                        </tbody>                                                 
                    </table>
                    
                </div>
            </div>

            <div class="column is-3">
                <div  class="panel">
                    <p class="panel-heading background-2  cp" @click="orderAstecsAnaliseVisita==2 ? orderAstecsAnaliseVisita= 0 : orderAstecsAnaliseVisita++; ordenar('astecsAnaliseVisita')">                  
                        <span><b-icon :icon="iconeorderAstecsAnaliseVisita"  size="is-small"> </b-icon></span>                                        
                        {{$t('ASTECS.ANALISEVISITA')}} 
                        ({{ listaAstecsAnaliseVisita.length}})
                        <span v-if="listaAstecsAnaliseVisita.filter(x=>x.atraso).length>0" class="ml-1 tag is-danger blink_me" title="Prazo vencido">{{ listaAstecsAnaliseVisita.filter(x=>x.atraso).length }}</span>                          
                    </p>
                    <router-link  :to="{ name: 'agenda', query:{tipo: 5,filtrarTodos:true}, params: {voltarTela: 'astecs' } }" class="button is-link is-outlined is-fullwidth">
                            {{$t('ATENDIMENTO.ABRIRCALENDARIO')}}
                    </router-link>                        
                    

                    <table class="table is-fullwidth is-striped is-hoverable">     
                        <tbody>
                            <tr :class="retornaEstiloLinha(item)" v-for="(item, index) in listaAstecsAnaliseVisita" v-bind:key="index">
                                
                                <td>
                                    <span>{{item.clienteCodigoExterno}} </span>
                                    <span   class="cp" @click="abrirGuia(item.guiaId)">
                                        <b-icon v-if="item.guiaId > 0"  icon="link"
                                                        size="is-small"                                    
                                                        :title="$t('GUIALIST.ATENDIMENTOVINCULADO')"
                                                        type="is-link"></b-icon>    
                                    <b-icon v-if="item.dataHoraAgendamentoAstec"
                                                        icon="calendar"
                                                        size="is-small"
                                                        type="is-info"                                    
                                                        :title="$t('VENDAS.AGENDAMENTOENTREGAREALIZADO')"></b-icon>                                                                                                  

                                    </span>                        
                                </td>                                
                                <td class="pl-0 pr-0">
                                    <b-tooltip  size="is-small" position="is-top" type="is-light"  > 
                                        <span class="is-size-7 highlight">{{item.clienteNome}} </span>
                                    </b-tooltip>  
                                </td>                                
                                <td>
                                    <div class="is-inline-flex">
                                        <router-link v-if="isInRole('astecs-conclusaovisita')" :to="{ name: 'guia-astec', params: { id: item.id, paraAnaliseVisita:true}}" class="button is-small is-primary" title="Abrir Astec">
                                            <b-icon icon="pencil" size="is-small"></b-icon>
                                        </router-link> 
                                        <b-button  class="is-small"  @click="confirmarInclusaoObservacao( item.id)" 
                                        :title="$t('ASTECS.INCLUIROBSERVACAO')" icon-left="comment"></b-button>                                                                                                                                                                          
                                    </div>                                          
                                    
                                </td>                                
                            </tr>  
                        </tbody>                                                 
                    </table>
                    
                </div>
            </div>            

            <div class="column is-3">
                <div  class="panel">
                    <p class="panel-heading background-2  cp" @click="orderAstecsEmAndamento==2 ? orderAstecsEmAndamento= 0 : orderAstecsEmAndamento++; ordenar('astecsEmAndamento')">                  
                        <span><b-icon :icon="iconeorderAstecsEmAndamento"  size="is-small"> </b-icon></span>                                                            
                        {{$t('ASTECS.ANDAMENTO')}} 
                        ({{ listaAstecsAndamento.length}})
                        <span v-if="listaAstecsAndamento.filter(x=>x.atraso).length>0" class="ml-1 tag is-danger blink_me" title="Prazo vencido">{{ listaAstecsAndamento.filter(x=>x.atraso).length }}</span>                          
                    </p>

                        <router-link   :to="{ name: 'guia-astec-list', query: { tipo:'emandamento' }  }" class="button is-link is-outlined is-fullwidth">
                            {{$t('ASTECS.LISTAREMANDAMENTO')}}
                             <span class="ml-1 tag is-info" title="Aguardando prazo">{{ listaAstecsAndamento.length }}</span>                                                           
                        </router-link>                         
       
                    
                </div>
            </div>

        </div>

        <div class=" columns has-text-centered" style="background-color: rgb(34 81 99 / 22%); display:block; ">
            <br>
            <h1 class="title">Solicitações</h1> 
        </div>        
        <div class="p-2 columns" style="background-color: rgb(34 81 99 / 22%); ">
 
            <div class="column is-3">
                <div  class="panel">
                    <p class="panel-heading background-2  cp" @click="orderOcorrenciasAnaliseFabrica==2 ? orderOcorrenciasAnaliseFabrica= 0 : orderOcorrenciasAnaliseFabrica++; ordenar('ocorrenciasAnaliseFabrica')">                  
                        <span><b-icon :icon="iconeorderOcorrenciasAnaliseFabrica"  size="is-small"> </b-icon></span>                                                                                
                        {{$t('ASTECS.ANALISEFABRICA')}} 
                        ({{ listaOcorrenciasAnaliseFabrica.length}})
                        <span v-if="listaOcorrenciasAnaliseFabrica.filter(x=>x.atraso).length>0" class="ml-1 tag is-danger blink_me" title="Prazo vencido">{{ listaOcorrenciasAnaliseFabrica.filter(x=>x.atraso).length }}</span>                          
                    </p>

                    <table class="table is-fullwidth is-striped is-hoverable">     
                        <tbody>
                            <tr :class="retornaEstiloLinha(item)" v-for="(item, index) in listaOcorrenciasAnaliseFabrica" v-bind:key="index">
                                
                                <td>
                                    <span v-if=" item.dataHoraAprovacaoFabrica==null"   class="cp" @click="aprovacaoCustoFabrica(item.id)">

                                        <b-icon v-if="item.dataHoraDevolucao"
                                                        icon="help"
                                                        size="is-small"
                                                        type="is-danger"                                    
                                                        :title="$t('ASTECS.DEVOLUCAOSUPERVISOR')"></b-icon> 
                                        <b-icon v-else icon="timer-sand"
                                                        size="is-small"
                                                        type="is-black"                                    
                                                        :title="$t('POSVENDAS.AGUARDANDOSUPERVISORRESOLVER')"></b-icon> 
                                                                                                
                                    </span>                                                                 
                                </td>                                
                                <td class="pl-0 pr-0">
                                    <b-tooltip  size="is-small" position="is-top" type="is-light"  > 
                                        <template v-slot:content>                                            
                                            <b>TIPO:</b> <span> {{item.tipoNome}}</span><br>
                                            <b>DESCRIÇÃO:</b> <span v-html="tratamentoQuebraLinha(item.observacao)"></span><br>                                                                                       
                                        </template>                                             
                                        <span class="is-size-7">{{item.clienteNome}} </span> 
                                    </b-tooltip>                                                                                                         
                                </td>                                
                                <td>
                                    <div class="is-inline-flex">
        
                                        <b-button v-if="isInRole('astecs-analisefabrica')"  
                                            :title="$t('SISTEMA.EDITAR')" class="is-small is-primary" @click="incluirOcorrencia(item)" icon-left="pencil"></b-button>                                                                                                                                                      
                                    </div>      

                                </td>                                
                            </tr>  
                        </tbody>                                                 
                    </table>
                    
                </div>
            </div>

            <div class="column is-3">
                <div  class="panel">
                    <p class="panel-heading background-2  cp" @click="orderOcorrenciasAprovacaoOrcamento==2 ? orderOcorrenciasAprovacaoOrcamento= 0 : orderOcorrenciasAprovacaoOrcamento++; ordenar('ocorrenciasAprovacaoOrcamento')">                  
                        <span><b-icon :icon="iconeorderOcorrenciasAprovacaoOrcamento"  size="is-small"> </b-icon></span>                                                                                                    
                        {{$t('ASTECS.ORCAMENTO')}} 
                        ({{ listaOcorrenciasAprovacaoOrcamento.length}})
                        <span v-if="listaOcorrenciasAprovacaoOrcamento.filter(x=>x.atraso).length>0" class="ml-1 tag is-danger blink_me" title="Prazo vencido">{{ listaOcorrenciasAprovacaoOrcamento.filter(x=>x.atraso).length }}</span>                          
                    </p>

                    <b-collapse class="panel m-0" animation="slide" :open="false"  v-model="collapses[0]">
                        <template #trigger="props">
                            <div
                                class="card-header"
                                role="button"                                
                                :aria-expanded="props.open">
                                <p class="card-header-title">
                                    Solicitados ({{  listaOcorrenciasAprovacaoOrcamento.filter(x=> x.dataHoraAprovacaoOrcamento==null).length}})
                                </p>
                                <a class="card-header-icon">
                                    <b-icon
                                        :icon="props.open ? 'menu-down' : 'menu-up'">
                                    </b-icon>
                                </a>
                            </div>
                        </template>

                        <table class="table is-fullwidth is-striped is-hoverable">     
                            <tbody>
                                <tr :class="retornaEstiloLinha(item)" v-for="(item, index) in listaOcorrenciasAprovacaoOrcamento.filter(x=> x.dataHoraAprovacaoOrcamento==null)" v-bind:key="index">
                                    
                                    <td>
                                        <span>{{item.clienteCodigoExterno}} </span>                   
                                    </td>                                
                                    <td class="pl-0 pr-0">
                                        <b-tooltip  size="is-small" position="is-top" type="is-light"  > 
                                            <template v-slot:content>                                            
                                                <b>TIPO:</b> <span> {{item.tipoNome}}</span><br>
                                                <b>DESCRIÇÃO:</b> <span v-html="tratamentoQuebraLinha(item.observacao)"></span><br>                                                                                       
                                            </template>                                             
                                            <span class="is-size-7">{{item.clienteNome}} </span> 
                                        </b-tooltip> 
                                    </td>                                
                                    <td>
                                        <div class="is-inline-flex">                    
                                            <b-button v-if="isInRole('astecs-orcamento')"  
                                                :title="$t('SISTEMA.EDITAR')" class="is-small is-primary" @click="incluirOcorrencia(item)" icon-left="pencil"></b-button>                                                                                                                                                      
                                        </div>        
                                    </td>                                
                                </tr>  
                            </tbody>                                                 
                        </table>                        
                    </b-collapse>
                    
                    <b-collapse class="panel m-0" animation="slide" :open="false"  v-model="collapses[1]">
                        <template #trigger="props">
                            <div
                                class="card-header"
                                role="button"                                
                                :aria-expanded="props.open">
                                <p class="card-header-title">
                                    Em Negociação ({{  listaOcorrenciasAprovacaoOrcamento.filter(x=> x.dataHoraAprovacaoOrcamento!=null).length}})
                                </p>
                                <a class="card-header-icon">
                                    <b-icon
                                        :icon="props.open ? 'menu-down' : 'menu-up'">
                                    </b-icon>
                                </a>
                            </div>
                        </template>

                        <table class="table is-fullwidth is-striped is-hoverable">     
                            <tbody>
                                <tr :class="retornaEstiloLinha(item)" v-for="(item, index) in listaOcorrenciasAprovacaoOrcamento.filter(x=> x.dataHoraAprovacaoOrcamento!=null)" v-bind:key="index">
                                    
                                    <td>
                                        <span>{{item.clienteCodigoExterno}} </span>                   
                                    </td>                                
                                    <td class="pl-0 pr-0">
                                        <b-tooltip  size="is-small" position="is-top" type="is-light"  > 
                                            <template v-slot:content>                                            
                                                <b>TIPO:</b> <span> {{item.tipoNome}}</span><br>
                                                <b>DESCRIÇÃO:</b> <span v-html="tratamentoQuebraLinha(item.observacao)"></span><br>                                                                                       
                                            </template>                                             
                                            <span class="is-size-7">{{item.clienteNome}} </span> 
                                        </b-tooltip> 
                                    </td>                                
                                    <td>
                                        <div class="is-inline-flex">                    
                                            <b-button v-if="isInRole('astecs-orcamento')"  
                                                :title="$t('SISTEMA.EDITAR')" class="is-small is-primary" @click="incluirOcorrencia(item)" icon-left="pencil"></b-button>                                                                                                                                                      
                                        </div>        
                                    </td>                                
                                </tr>  
                            </tbody>                                                 
                        </table>                        
                    </b-collapse>                         

                    
                </div>
            </div>

            <div class="column is-3">
                <div  class="panel">
                    <p class="panel-heading background-2  cp" @click="orderOcorrenciasAprovacaoFinanceiro==2 ? orderOcorrenciasAprovacaoFinanceiro= 0 : orderOcorrenciasAprovacaoFinanceiro++; ordenar('ocorrenciasAprovacaoFinanceiro')">                  
                        <span><b-icon :icon="iconeorderOcorrenciasAprovacaoFinanceiro"  size="is-small"> </b-icon></span>                                                                                                                          
                        {{$t('ASTECS.FINANCEIRO')}} 
                        ({{ listaOcorrenciasAprovacaoFinanceiro.length}})
                        <span v-if="listaOcorrenciasAprovacaoFinanceiro.filter(x=>x.atraso).length>0" class="ml-1 tag is-danger blink_me" title="Prazo vencido">{{ listaOcorrenciasAprovacaoFinanceiro.filter(x=>x.atraso).length }}</span>                          
                    </p>

                    <table class="table is-fullwidth is-striped is-hoverable">     
                        <tbody>
                            <tr :class="retornaEstiloLinha(item)" v-for="(item, index) in listaOcorrenciasAprovacaoFinanceiro" v-bind:key="index">
                                
                                <td>
                                    <span>{{item.clienteCodigoExterno}} </span>                        
                                </td>                                
                                <td class="pl-0 pr-0">
                                    <b-tooltip  size="is-small" position="is-top" type="is-light"  > 
                                        <template v-slot:content>                                            
                                            <b>TIPO:</b> <span> {{item.tipoNome}}</span><br>
                                            <b>DESCRIÇÃO:</b> <span v-html="tratamentoQuebraLinha(item.observacao)"></span><br>   
                                            <span v-if="item.codigoContrato>0">
                                                <b>CONTRATO: </b> {{item.codigoContrato}}
                                                <br>
                                            </span>                                                                                                                                  
                                        </template>                                             
                                        <span class="is-size-7">{{item.clienteNome}} </span> 
                                    </b-tooltip> 
                                </td>                                
                                <td>
                                    <div class="is-inline-flex">

                                        <b-button v-if="isInRole('astecs-financeiro')"  
                                            :title="$t('SISTEMA.EDITAR')" class="is-small is-primary" @click="incluirOcorrencia(item)" icon-left="pencil"></b-button>                                                                                                                                                      

                                    </div>      
        
                                </td>                                
                            </tr>  
                        </tbody>                                                 
                    </table>
                    
                </div>
            </div>

            <div class="column is-3">
                <div  class="panel">
                    <p class="panel-heading background-2  cp" @click="orderOcorrenciasEmissao==2 ? orderOcorrenciasEmissao= 0 : orderOcorrenciasEmissao++; ordenar('ocorrenciasEmissao')">                  
                        <span><b-icon :icon="iconeorderOcorrenciasEmissao"  size="is-small"> </b-icon></span>                                                                                                                                                  
                        {{$t('ASTECS.EMISSAO')}} 
                        ({{ listaOcorrenciasEmissao.length}})
                        <span v-if="listaOcorrenciasEmissao.filter(x=>x.atraso).length>0" class="ml-1 tag is-danger blink_me" title="Prazo vencido">{{ listaOcorrenciasEmissao.filter(x=>x.atraso).length }}</span>                          
                    </p>

                    <table class="table is-fullwidth is-striped is-hoverable">     
                        <tbody>
                            <tr :class="retornaEstiloLinha(item)" v-for="(item, index) in listaOcorrenciasEmissao" v-bind:key="index">
                                
                                <td>
                                    <span>{{item.clienteCodigoExterno}} </span>
                                        <b-icon v-if="item.dataHoraDevolucao"
                                                        icon="help"
                                                        size="is-small"
                                                        type="is-danger"                                    
                                                        :title="$t('ASTECS.DEVOLUCAOSUPERVISOR')"></b-icon>                                      
                                
                                </td>                                
                                <td class="pl-0 pr-0">
                                    <b-tooltip  size="is-small" position="is-top" type="is-light"  > 
                                        <template v-slot:content>                                            
                                            <b>TIPO:</b> <span> {{item.tipoNome}}</span><br>
                                            <b>DESCRIÇÃO:</b> <span v-html="tratamentoQuebraLinha(item.observacao)"></span><br>     
                                            <span v-if="item.codigoContrato>0">
                                                <b>CONTRATO: </b> {{item.codigoContrato}}
                                                <br>
                                            </span>                                                                                                                               
                                        </template>                                             
                                        <span class="is-size-7">{{item.clienteNome}} </span> 
                                    </b-tooltip> 
                                </td>                                
                                <td>
                                    <div class="is-inline-flex">
                                        <b-button v-if="isInRole('astecs-conferencia')"  
                                            :title="$t('SISTEMA.EDITAR')" class="is-small is-primary" @click="incluirOcorrencia(item)" icon-left="pencil"></b-button>                                                                                                                                                                                                                                           
                                    </div>      

                                </td>                                
                            </tr>  
                        </tbody>                                                 
                    </table>
                    
                </div>
            </div>
                
        </div>   
        
        <div class="columns" style="background-color: rgb(34 81 99 / 22%); ">
           
            <div class="column is-3">
                <div  class="panel">
                    <p class="panel-heading background-2  cp" @click="orderOcorrenciasEnvioFabrica==2 ? orderOcorrenciasEnvioFabrica= 0 : orderOcorrenciasEnvioFabrica++; ordenar('ocorrenciasEnvioFabrica')">                  
                        <span><b-icon :icon="iconeorderOcorrenciasEnvioFabrica"  size="is-small"> </b-icon></span>                                                                                                                                                  
                        {{$t('ASTECS.ENVIOFABRICA')}} 
                        ({{ listaOcorrenciasEnvioFabrica.length}})
                        <span v-if="listaOcorrenciasEnvioFabrica.filter(x=>x.atraso).length>0" class="ml-1 tag is-danger blink_me" title="Prazo vencido">{{ listaOcorrenciasEnvioFabrica.filter(x=>x.atraso).length }}</span>                          
                    </p>

                    <table class="table is-fullwidth is-striped is-hoverable">     
                        <tbody>
                            <tr :class="retornaEstiloLinha(item)" v-for="(item, index) in listaOcorrenciasEnvioFabrica" v-bind:key="index">
                                
                                <td>
                                    <span>{{item.clienteCodigoExterno}} </span>
                                
                                </td>                                
                                <td class="pl-0 pr-0">
                                    <b-tooltip  size="is-small" position="is-top" type="is-light"  > 
                                        <template v-slot:content>                                            
                                            <b>TIPO:</b> <span> {{item.tipoNome}}</span><br>
                                            <b>DESCRIÇÃO:</b> <span v-html="tratamentoQuebraLinha(item.observacao)"></span><br>     
                                            <span v-if="item.codigoContrato>0">
                                                <b>CONTRATO: </b> {{item.codigoContrato}}
                                                <br>
                                            </span>                                                                                                                               
                                        </template>                                             
                                        <span class="is-size-7">{{item.clienteNome}} </span> 
                                    </b-tooltip> 
                                </td>                                
                                <td>
                                    <div class="is-inline-flex">
                                        <b-button v-if="isInRole('astecs-enviofabrica')"  
                                            :title="$t('SISTEMA.EDITAR')" class="is-small is-primary" @click="incluirOcorrencia(item)" icon-left="pencil"></b-button>                                                                                                                                                                                                                                           
                                    </div>      

                                </td>                                
                            </tr>  
                        </tbody>                                                 
                    </table>
                    
                </div>
            </div> 
            <div class="column is-3">
                <div  class="panel">
                    <p class="panel-heading background-2  cp" @click="orderOcorrenciasFinalizarEfinance==2 ? orderOcorrenciasFinalizarEfinance= 0 : orderOcorrenciasFinalizarEfinance++; ordenar('ocorrenciasFinalizarEfinance')">                  
                        <span><b-icon :icon="iconeorderOcorrenciasFinalizarEfinance"  size="is-small"> </b-icon></span>                                                                                                                                                  
                        {{$t('ASTECS.FINALIZAREFINANCE')}} 
                        ({{ listaOcorrenciasFinalizarEfinance.length}})
                        <span v-if="listaOcorrenciasFinalizarEfinance.filter(x=>x.atraso).length>0" class="ml-1 tag is-danger blink_me" title="Prazo vencido">{{ listaOcorrenciasFinalizarEfinance.filter(x=>x.atraso).length }}</span>                          
                    </p>

                    <table class="table is-fullwidth is-striped is-hoverable">     
                        <tbody>
                            <tr :class="retornaEstiloLinha(item)" v-for="(item, index) in listaOcorrenciasFinalizarEfinance" v-bind:key="index">
                                
                                <td>
                                    <span>{{item.clienteCodigoExterno}} </span>
                                
                                </td>                                
                                <td class="pl-0 pr-0">
                                    <b-tooltip  size="is-small" position="is-top" type="is-light"  > 
                                        <template v-slot:content>                                            
                                            <b>TIPO:</b> <span> {{item.tipoNome}}</span><br>
                                            <b>DESCRIÇÃO:</b> <span v-html="tratamentoQuebraLinha(item.observacao)"></span><br>     
                                            <span v-if="item.codigoContrato>0">
                                                <b>CONTRATO: </b> {{item.codigoContrato}}
                                                <br>
                                            </span>                                                                                                                               
                                        </template>                                             
                                        <span class="is-size-7">{{item.clienteNome}} </span> 
                                    </b-tooltip> 
                                </td>                                
                                <td>
                                    <div class="is-inline-flex">
                                        <b-button v-if="isInRole('astecs-finalizar-efinance')"  
                                            :title="$t('SISTEMA.EDITAR')" class="is-small is-primary" @click="incluirOcorrencia(item)" icon-left="pencil"></b-button>                                                                                                                                                                                                                                           
                                    </div>      

                                </td>                                
                            </tr>  
                        </tbody>                                                 
                    </table>
                    
                </div>
            </div> 
            <div class="column is-3">
                <div  class="panel">
                    <p class="panel-heading background-2  cp" >                  
                        <span><b-icon size="is-small"> </b-icon></span>                                                                                                                                                  
                        {{$t('ASTECS.INSTALACOESFUTURAS')}} 
                        ({{ listaOcorrenciasInstalacoesFuturas.length}})
                        <span v-if="listaOcorrenciasInstalacoesFuturas.filter(x=>x.atraso).length>0" class="ml-1 tag is-danger blink_me" title="Prazo vencido">{{ listaOcorrenciasInstalacoesFuturas.filter(x=>x.atraso).length }}</span>                          
                    </p>

                        <router-link   :to="{ name: 'guia-astec-list', query: { tipo:'instalacaofutura' }  }" class="button is-link is-outlined is-fullwidth">
                            {{$t('ASTECS.INSTALACOESFUTURAS')}}   
                            <span class="ml-1 tag is-info" >{{ listaOcorrenciasInstalacoesFuturas.length }}</span>                                                                                     
                        </router-link>   

                             
                </div>
            </div> 
            <div class="column is-3">
                <div  class="panel">
                    <p class="panel-heading background-2  cp" @click="orderOcorrenciasEntrega==2 ? orderOcorrenciasEntrega= 0 : orderOcorrenciasEntrega++; ordenar('ocorrenciasEntrega')">                  
                        <span><b-icon :icon="iconeorderOcorrenciasEntrega"  size="is-small"> </b-icon></span>                       
                        {{$t('ASTECS.ENTREGA')}} 
                        ({{ listaOcorrenciasEntrega.length}})
                        <span v-if="listaOcorrenciasEntrega.filter(x=>x.atraso).length>0" class="ml-1 tag is-danger blink_me" title="Prazo vencido">{{ listaOcorrenciasEntrega.filter(x=>x.atraso).length }}</span>                          
                    </p>
                    <router-link  :to="{ name: 'agenda', query:{tipo: 5,filtrarTodos:true}, params: {voltarTela: 'astecs' } }" class="button is-link is-outlined is-fullwidth">
                            {{$t('ATENDIMENTO.ABRIRCALENDARIO')}}
                    </router-link> 
                    <table class="table is-fullwidth is-striped is-hoverable">     
                        <tbody>
                            <tr :class="retornaEstiloLinha(item)" v-for="(item, index) in listaOcorrenciasEntrega" v-bind:key="index">
                                
                                <td>
                                    <span>{{item.clienteCodigoExterno}} </span>
                                    <b-icon v-if="item.dataHoraAgendamentoEntrega"
                                                        icon="calendar"
                                                        size="is-small"
                                                        type="is-info"                                    
                                                        :title="$t('VENDAS.AGENDAMENTOENTREGAREALIZADO')"></b-icon>                                      
                                 
                                </td>                                
                                <td class="pl-0 pr-0">
                                    <b-tooltip  size="is-small" position="is-top" type="is-light"  > 
                                        <template v-slot:content>                                            
                                            <b>TIPO:</b> <span> {{item.tipoNome}}</span><br>
                                            <b>DESCRIÇÃO:</b> <span v-html="tratamentoQuebraLinha(item.observacao)"></span><br> 
                                            <span v-if="item.dataHoraAgendamentoEntrega">       
                                                <b>DATA PARA ENTREGA: </b>  {{$moment(item.dataHoraAgendamentoEntrega).format('DD/MM/YYYY')}}                                                
                                            </span>                                                                                                                                   
                                        </template>                                             
                                        <span class="is-size-7">{{item.clienteNome}} </span> 
                                    </b-tooltip>                                     
                                </td>                                
                                <td>
                                    <div class="is-inline-flex">               
                                        <b-button v-if="isInRole('astecs-entrega')"  
                                            :title="$t('SISTEMA.EDITAR')" class="is-small is-primary" @click="incluirOcorrencia(item)" icon-left="pencil"></b-button>                                                                                                                                                                                                                                                                                                                               
                                    </div>      
     
                                </td>                                
                            </tr>  
                        </tbody>                                                 
                    </table>
                    
                </div>
            </div>                                              
            
        </div>

        <div class="columns" style="background-color: rgb(34 81 99 / 22%); ">
 


            <div class="column is-3">
                <div  class="panel">
                    <p class="panel-heading background-2  cp" @click="orderOcorrenciasParaInstalacao==2 ? orderOcorrenciasParaInstalacao= 0 : orderOcorrenciasParaInstalacao++; ordenar('ocorrenciasParaInstalacao')">                  
                        <span><b-icon :icon="iconeorderOcorrenciasParaInstalacao"  size="is-small"> </b-icon></span>                            
                        {{$t('ASTECS.PARAINSTALACAO')}} 
                        ({{ listaOcorrenciasParaInstalacao.length}})
                        <span v-if="listaOcorrenciasParaInstalacao.filter(x=>x.atraso).length>0" class="ml-1 tag is-danger blink_me" title="Prazo vencido">{{ listaOcorrenciasParaInstalacao.filter(x=>x.atraso).length }}</span>                          
                    </p>
                    <router-link  :to="{ name: 'agenda', query:{tipo: 5,filtrarTodos:true}, params: {voltarTela: 'astecs' } }" class="button is-link is-outlined is-fullwidth">
                            {{$t('ATENDIMENTO.ABRIRCALENDARIO')}}
                    </router-link>                     

                    <table class="table is-fullwidth is-striped is-hoverable">     
                        <tbody>
                            <tr :class="retornaEstiloLinha(item)" v-for="(item, index) in listaOcorrenciasParaInstalacao" v-bind:key="index">
                                
                                <td>
                                    <span>{{item.clienteCodigoExterno}} </span>   
                                    <b-icon v-if="item.dataHoraInstalacao"
                                                        icon="calendar"
                                                        size="is-small"
                                                        type="is-info"                                    
                                                        :title="$t('VENDAS.AGENDAMENTOENTREGAREALIZADO')"></b-icon>                                                                                                         
                                </td>                                
                                <td class="pl-0 pr-0">
                                    <b-tooltip  size="is-small" position="is-top" type="is-light"  > 
                                        <template v-slot:content>                                            
                                            <b>TIPO:</b> <span> {{item.tipoNome}}</span><br>
                                            <b>DESCRIÇÃO:</b> <span v-html="tratamentoQuebraLinha(item.observacao)"></span><br>
                                            <span v-if="item.dataHoraInstalacao">       
                                                <b>PREVISÃO DE INSTALAÇÃO: </b>  {{$moment(item.dataHoraInstalacao).format('DD/MM/YYYY')}}                                                
                                            </span>                                                                                                                                   
                                        </template>                                             
                                        <span class="is-size-7">{{item.clienteNome}} </span> 
                                    </b-tooltip> 
                                 
                                </td>                                
                                <td>
                                    <div class="is-inline-flex">

                                        <b-button v-if="isInRole('astecs-parainstalacao')"  
                                            :title="$t('SISTEMA.EDITAR')" class="is-small is-primary" @click="incluirOcorrencia(item)" icon-left="pencil"></b-button>                                                                                                                                                                                                                                                                                                                                                                       
                                    </div>               
                                </td>                                
                            </tr>  
                        </tbody>                                                 
                    </table>
                    
                </div>
            </div>

            <div class="column is-3">
                <div  class="panel">
                    <p class="panel-heading background-2  cp" @click="orderOcorrenciasEmInstalacao==2 ? orderOcorrenciasEmInstalacao= 0 : orderOcorrenciasEmInstalacao++; ordenar('ocorrenciasEmInstalacao')">                  
                        <span><b-icon :icon="iconeorderOcorrenciasEmInstalacao"  size="is-small"> </b-icon></span>                                                   
                        {{$t('ASTECS.EMINSTALACAO')}} 
                        ({{ listaOcorrenciasEmInstalacao.length}})
                        <span v-if="listaOcorrenciasEmInstalacao.filter(x=>x.atraso).length>0" class="ml-1 tag is-danger blink_me" title="Prazo vencido">{{ listaOcorrenciasEmInstalacao.filter(x=>x.atraso).length }}</span>                          
                    </p>
                    <router-link  :to="{ name: 'agenda', query:{tipo: 5,filtrarTodos:true}, params: {voltarTela: 'astecs' } }" class="button is-link is-outlined is-fullwidth">
                            {{$t('ATENDIMENTO.ABRIRCALENDARIO')}}
                    </router-link>                              

                    <table class="table is-fullwidth is-striped is-hoverable">     
                        <tbody>
                            <tr :class="retornaEstiloLinha(item)" v-for="(item, index) in listaOcorrenciasEmInstalacao" v-bind:key="index">
                                
                                <td>
                                    <span>{{item.clienteCodigoExterno}} </span>                                 
                                </td>                                
                                <td class="pl-0 pr-0">
                                    <b-tooltip  size="is-small" position="is-top" type="is-light"  > 
                                        <template v-slot:content>                                            
                                            <b>TIPO:</b> <span> {{item.tipoNome}}</span><br>
                                            <b>DESCRIÇÃO:</b> <span v-html="tratamentoQuebraLinha(item.observacao)"></span><br>  
                                            <span v-if="item.dataHoraInstalacao">       
                                                <b>PREVISÃO DE INSTALAÇÃO: </b>  {{$moment(item.dataHoraInstalacao).format('DD/MM/YYYY')}}                                                
                                            </span>                                                                                                                                 
                                        </template>                                             
                                        <span class="is-size-7">{{item.clienteNome}} </span> 
                                    </b-tooltip> 
                                </td>                                
                                <td>
                                    <div class="is-inline-flex">
                                        
                                        <b-button v-if="isInRole('astecs-eminstalacao')"  
                                            :title="$t('SISTEMA.EDITAR')" class="is-small is-primary" @click="incluirOcorrencia(item)" icon-left="pencil"></b-button>                                                                                                                                                                                                                                                                                                                                                                                                               
                                    </div>                
                                </td>                                
                            </tr>  
                        </tbody>                                                 
                    </table>
                    
                </div>
            </div>

            <div class="column is-3">
    
            </div>

            <div class="column is-3">
    
            </div>            
                
        </div>           
                  
    </section>
</template>


<style scoped>
.has-background-dark {
    background-color: #363636d6 !important;
}

</style>

<script>
    import { mapState, mapGetters } from 'vuex'
    import modalInserirNovaAstec from '@/components/astecs/modalInserirNovaAstec.vue'  
    import modalObservacaoAstec  from '@/components/astecs/modalObservacaoAstec'
    import modalCadastroOcorrenciasAstec from '@/components/astecs/modalCadastroOcorrenciasAstec.vue'  


    export default {
        data() {
            return {        
            
                isLoading: false,
                listaAstecsAbertura:[],
                listaAstecsAgendamento:[],
                listaAstecsVisita:[],
                listaAstecsAnaliseVisita:[],
                listaAstecsAndamento:[],                   
                listaOcorrenciasAnaliseFabrica:[],
                listaOcorrenciasAprovacaoOrcamento:[],
                listaOcorrenciasAprovacaoFinanceiro:[],   
                listaOcorrenciasEmissao:[],         
                listaOcorrenciasEnvioFabrica:[], 
                listaOcorrenciasFinalizarEfinance:[],   
                listaOcorrenciasInstalacoesFuturas:[],   
                listaOcorrenciasEntrega:[],
                listaOcorrenciasParaInstalacao:[],
                listaOcorrenciasEmInstalacao:[], 
                
                orderAstecsAbertura: 0,
                iconeorderAstecsAbertura:'', 
                orderAstecsAgendamento: 0,
                iconeorderAstecsAgendamento:'',                     
                orderAstecsVisita: 0,
                iconeorderAstecsVisita:'',
                orderAstecsAnaliseVisita: 0,
                iconeorderAstecsAnaliseVisita:'',                                   
                orderAstecsEmAndamento: 0,
                iconeorderAstecsEmAndamento:'',                
                orderOcorrenciasAnaliseFabrica : 0,
                iconeorderOcorrenciasAnaliseFabrica:'',

                orderOcorrenciasAprovacaoOrcamento : 0,
                iconeorderOcorrenciasAprovacaoOrcamento:'',
                orderOcorrenciasAprovacaoFinanceiro : 0,
                iconeorderOcorrenciasAprovacaoFinanceiro:'',                  
                orderOcorrenciasEmissao : 0,
                iconeorderOcorrenciasEmissao:'',                 
                orderOcorrenciasEnvioFabrica : 0,
                iconeorderOcorrenciasEnvioFabrica :'', 
                orderOcorrenciasFinalizarEfinance : 0,
                iconeorderOcorrenciasFinalizarEfinance :'',                                 
                orderOcorrenciasEntrega : 0,
                iconeorderOcorrenciasEntrega :'',                
                orderOcorrenciasParaInstalacao : 0,
                iconeorderOcorrenciasParaInstalacao :'',                
                orderOcorrenciasEmInstalacao : 0,
                iconeorderOcorrenciasEmInstalacao :'',                
                
                queryCliente: this.$route.params.queryCliente ?? null,
                collapses: [false, false],  
            }
        },
        components: {  
                                  
        },
        computed: {
            ...mapState([
                'unidadeId',
                'config',
                'usuario'                
            ]),
            ...mapGetters([
                'isInRole'
            ])
        },
        watch: {            
            unidadeId: function(novaUnidade) {                 
                this.loadAsyncData()                                                
            },
        },         
        methods: {

            aprovacaoCustoFabrica(ocorrenciaId){

                if(!this.isInRole('astecs-analisefabrica'))
                    return;

                this.salvandoDados=true;
                const params = [];                                                                                                                      
                params.push(`id=${ocorrenciaId}`);   
                params.push(`aprovado=true`);    

                const obs = 'Aprovado Manualmente';
                params.push(`observacoes=${obs}`);  

                this.$buefy.dialog.confirm({
                title: 'Confirmar',
                message: this.$t('POSVENDAS.CONFIRMARFABRICAAPROVAR'),
                type: 'is-success',
                hasIcon: true,
                cancelText: 'Não',
                confirmText: 'Sim',
                onConfirm: () => {
                                                                                                                 
                                this.$http.get(`/api/astecs/ConfirmarAnaliseFabricaOcorrencia?${params.join('&')}`)                        
                                .then(res => res.data)
                                .then(data => {                                                
                                    this.salvandoDados=false;
                                }).finally(() => {                                
                                    this.salvandoDados = false;    
                                    this.$buefy.toast.open({
                                        duration: 10000,
                                        message: "Atualizada com sucesso",
                                        type: 'is-success',
                                        queue: false
                                    });                                                                                                 
                                    this.loadAsyncData();                          
                                    
                                }).catch((error) => {    

                                    this.$buefy.toast.open({
                                        duration: 5000,
                                        message: "Ocorreu um erro!",
                                        type: 'is-danger',
                                        queue: false
                                    });                                                    
                                    throw error;
                                });                               
      
                    }
                });                

            },                   

            incluirOcorrencia(item){
                this.$buefy.modal.open({
                    parent: this,
                    component: modalCadastroOcorrenciasAstec,
                    props: {
                        id: item.id,
                        clienteCodigoExterno: item.clienteCodigoExterno,
                        astecId: item.astecId                      
                    },
                    events: {
                        carregarAstecs: this.carregarAstecs,
                    },
                    hasModalCard: true,
                    trapFocus: true,
                    fullScreen:true
                })
            },                           
            tratamentoQuebraLinha(texto){                
                return (texto) ? texto.replaceAll('\\n', '<br/>') : '';
            },             
            confirmarInclusaoObservacao(guiaId) {
                this.$buefy.modal.open({
                    parent: this,
                    component: modalObservacaoAstec,
                    props: {
                        guia: {id: guiaId}                                              
                    },
                    events: {
                        loadData: this.loadAsyncData
                    },                    
                    hasModalCard: true,
                    trapFocus: true
                })
            },                  
            verificaPesquisarCliente(){
                
                if(this.queryCliente){
                    this.isLoading = true;
                    setTimeout(() => { this.pesquisarCliente(this.queryCliente)},5000);                                    
                }

            },            
            pesquisarCliente(queryCliente){
                this.isLoading = false;                             
                //this.collapsesOpenAll();                    
                setTimeout(() => { this.barraRolagemCliente(this.queryCliente)},1000);                     
             
            },
            barraRolagemCliente(queryCliente){
                const searchElements = document.querySelectorAll(".highlight"); // Seleciona os elementos com a classe 'searchable'


                let found = false;

                searchElements.forEach(element => {
                    const regex = new RegExp(`(${queryCliente})`, "gi");
                    element.innerHTML = element.innerHTML.replace(regex, `<mark>$1</mark>`);

                    // Rola até o primeiro destaque encontrado
                    if (!found) {
                    const firstHighlight = element.querySelector("mark");
                    if (firstHighlight) {
                        firstHighlight.scrollIntoView({ behavior: "smooth", block: "center" });
                        found = true; // Garante que rola apenas para o primeiro match
                    }
                    }
                });   
            },
            collapsesOpenAll() {
                this.collapses = this.collapses.map(() => true);
                this.$forceUpdate();
            },            
            abrirGuia(guiaId){            
                this.$router.push({ name: 'guia', params: { id: guiaId, guiaList:true}})
            },            
            verificaOrdenarIcone(item){                
                if(item==0){
                    return '';
                }else if(item==1){
                    return 'sort-alphabetical-ascending';
                }else if(item==2){
                    return 'sort-alphabetical-descending';
                }else{
                    return '';
                }
            },
            ordenar(etapa){
                if(etapa == 'astecsAbertura'){
                    this.iconeorderAstecsAbertura = this.verificaOrdenarIcone(this.orderAstecsAbertura);   
                    this.astecsAbertura();            
                }else if( etapa == 'astecsAgendamento'){
                    this.iconeorderAstecsAgendamento = this.verificaOrdenarIcone(this.orderAstecsAgendamento);   
                    this.astecsAgendamento();            
                }else if( etapa == 'astecsVisita'){
                    this.iconeorderAstecsVisita = this.verificaOrdenarIcone(this.orderAstecsVisita);   
                    this.astecsConcluirVisita();            
                }else if( etapa == 'astecsAnaliseVisita'){
                    this.iconeorderAstecsAnaliseVisita = this.verificaOrdenarIcone(this.orderAstecsAnaliseVisita);   
                    this.astecsConcluirVisita();            
                }else if( etapa == 'astecsEmAndamento'){
                    this.iconeorderAstecsEmAndamento = this.verificaOrdenarIcone(this.orderAstecsEmAndamento);   
                    this.astecsEmAndamento();    
                }else if( etapa == 'ocorrenciasEmissao'){
                    this.iconeorderOcorrenciasEmissao = this.verificaOrdenarIcone(this.orderOcorrenciasEmissao);   
                    this.ocorrenciasEmissao();            
                }else if( etapa == 'ocorrenciasAnaliseFabrica'){
                    this.iconeorderOcorrenciasAnaliseFabrica = this.verificaOrdenarIcone(this.orderOcorrenciasAnaliseFabrica);   
                    this.ocorrenciasAnaliseFabrica();            
                }else if( etapa == 'ocorrenciasAprovacaoOrcamento'){
                    this.iconeorderOcorrenciasAprovacaoOrcamento = this.verificaOrdenarIcone(this.orderOcorrenciasAprovacaoOrcamento);   
                    this.ocorrenciasAprovacaoOrcamento();            
                }else if( etapa == 'ocorrenciasAprovacaoFinanceiro'){
                    this.iconeorderOcorrenciasAprovacaoFinanceiro = this.verificaOrdenarIcone(this.orderOcorrenciasAprovacaoFinanceiro);   
                    this.ocorrenciasAprovacaoFinanceiro();            
                }else if( etapa == 'ocorrenciasEnvioFabrica'){
                    this.iconeorderOcorrenciasEnvioFabrica = this.verificaOrdenarIcone(this.orderOcorrenciasEnvioFabrica);   
                    this.ocorrenciasEnvioFabrica();            
                }else if( etapa == 'ocorrenciasFinalizarEfinance'){
                    this.iconeorderOcorrenciasFinalizarEfinance = this.verificaOrdenarIcone(this.orderOcorrenciasFinalizarEfinance);   
                    this.ocorrenciasFinalizarEfinance();            
                }else if( etapa == 'ocorrenciasEntrega'){
                    this.iconeorderOcorrenciasEntrega = this.verificaOrdenarIcone(this.orderOcorrenciasEntrega);   
                    this.ocorrenciasEntrega();            
                }else if( etapa == 'ocorrenciasParaInstalacao'){
                    this.iconeorderOcorrenciasParaInstalacao = this.verificaOrdenarIcone(this.orderOcorrenciasParaInstalacao);   
                    this.ocorrenciasParaInstalacao();            
                }else if( etapa == 'ocorrenciasEmInstalacao'){
                    this.iconeorderOcorrenciasEmInstalacao = this.verificaOrdenarIcone(this.orderOcorrenciasEmInstalacao);   
                    this.ocorrenciasEmInstalacao();            
                }
                

                

                
            },            
            astecsAbertura(){

                const params = [                    
                    `unidadeId=${this.unidadeId}`,
                    `order=${this.orderAstecsAbertura}`                                                      
                ];
                
                this.$http.get(`/api/dashboard/astecsAbertura?${params.join('&')}`)
                        .then(res => res.data)
                        .then(data => {   
                        this.listaAstecsAbertura = data;
                    })
                    .catch((error) => {
                        this.listaAstecsAbertura = []
                        throw error
                    })
                    .finally(() => {
                        this.isFetching = false
                    })                

            },     
            astecsAgendamento(){

                const params = [                    
                    `unidadeId=${this.unidadeId}`,
                    `order=${this.orderAstecsAgendamento}`                                                      
                ];
                
                this.$http.get(`/api/dashboard/astecsAgendamento?${params.join('&')}`)
                        .then(res => res.data)
                        .then(data => {   
                        this.listaAstecsAgendamento = data;
                    })
                    .catch((error) => {
                        this.listaAstecsAgendamento = []
                        throw error
                    })
                    .finally(() => {
                        this.isFetching = false
                    })                

            },               
            
            astecsConcluirVisita(){

                const params = [                    
                    `unidadeId=${this.unidadeId}`,
                    `order=${this.orderAstecsAgendamento}`                                                      
                ];
                
                this.$http.get(`/api/dashboard/astecsConcluirVisita?${params.join('&')}`)
                        .then(res => res.data)
                        .then(data => {   
                        this.listaAstecsVisita = data;
                    })
                    .catch((error) => {
                        this.listaAstecsVisita = []
                        throw error
                    })
                    .finally(() => {
                        this.isFetching = false
                    })                

            },        
            
            astecsAnaliseVisita(){

                const params = [                    
                    `unidadeId=${this.unidadeId}`,
                    `order=${this.orderAstecsAgendamento}`                                                      
                ];
                
                this.$http.get(`/api/dashboard/AstecsAnaliseVisita?${params.join('&')}`)
                        .then(res => res.data)
                        .then(data => {   
                        this.listaAstecsAnaliseVisita = data;
                    })
                    .catch((error) => {
                        this.listaAstecsAnaliseVisita = []
                        throw error
                    })
                    .finally(() => {
                        this.isFetching = false
                    })                

            },        

            astecsEmAndamento(){

                const params = [                    
                    `unidadeId=${this.unidadeId}`,
                    `order=${this.orderAstecsEmAndamento}`                                                      
                ];
                
                this.$http.get(`/api/dashboard/astecsEmAndamento?${params.join('&')}`)
                        .then(res => res.data)
                        .then(data => {   
                        this.listaAstecsAndamento = data;
                    })
                    .catch((error) => {
                        this.listaAstecsAndamento = []
                        throw error
                    })
                    .finally(() => {
                        this.isFetching = false
                    })                

            },                       

            ocorrenciasAnaliseFabrica(){

                const params = [                    
                    `unidadeId=${this.unidadeId}`,
                    `order=${this.orderOcorrenciasAnaliseFabrica}`                                                      
                ];
                
                this.$http.get(`/api/dashboard/OcorrenciasAnaliseFabrica?${params.join('&')}`)
                        .then(res => res.data)
                        .then(data => {   
                        this.listaOcorrenciasAnaliseFabrica = data;
                    })
                    .catch((error) => {
                        this.listaOcorrenciasAnaliseFabrica = []
                        throw error
                    })
                    .finally(() => {
                        this.isFetching = false
                    })                

            },   
            
            ocorrenciasAprovacaoOrcamento(){

                const params = [                    
                    `unidadeId=${this.unidadeId}`,
                    `order=${this.orderOcorrenciasAprovacaoOrcamento}`                                                      
                ];
                
                this.$http.get(`/api/dashboard/OcorrenciasAprovacaoOrcamento?${params.join('&')}`)
                        .then(res => res.data)
                        .then(data => {   
                        this.listaOcorrenciasAprovacaoOrcamento = data;
                    })
                    .catch((error) => {
                        this.listaOcorrenciasAprovacaoOrcamento = []
                        throw error
                    })
                    .finally(() => {
                        this.isFetching = false
                    })                

            },                       
                     
            
            ocorrenciasEmissao(){

                const params = [                    
                    `unidadeId=${this.unidadeId}`,
                    `order=${this.orderOcorrenciasAprovacaoFinanceiro}`                                                      
                ];
                
                this.$http.get(`/api/dashboard/OcorrenciasEmissao?${params.join('&')}`)
                        .then(res => res.data)
                        .then(data => {   
                        this.listaOcorrenciasEmissao = data;
                    })
                    .catch((error) => {
                        this.listaOcorrenciasEmissao = []
                        throw error
                    })
                    .finally(() => {
                        this.isFetching = false
                    })                

            }, 

            ocorrenciasAprovacaoFinanceiro(){

                const params = [                    
                    `unidadeId=${this.unidadeId}`,
                    `order=${this.orderOcorrenciasAprovacaoFinanceiro}`                                                      
                ];
                
                this.$http.get(`/api/dashboard/OcorrenciasAprovacaoFinanceiro?${params.join('&')}`)
                        .then(res => res.data)
                        .then(data => {   
                        this.listaOcorrenciasAprovacaoFinanceiro = data;
                    })
                    .catch((error) => {
                        this.listaOcorrenciasAprovacaoFinanceiro = []
                        throw error
                    })
                    .finally(() => {
                        this.isFetching = false
                    })                

            },   
            
            ocorrenciasEnvioFabrica(){

                const params = [                    
                    `unidadeId=${this.unidadeId}`,
                    `order=${this.orderOcorrenciasEnvioFabrica}`                                                      
                ];
                
                this.$http.get(`/api/dashboard/OcorrenciasEnvioFabrica?${params.join('&')}`)
                        .then(res => res.data)
                        .then(data => {   
                        this.listaOcorrenciasEnvioFabrica = data;
                    })
                    .catch((error) => {
                        this.listaOcorrenciasEnvioFabrica = []
                        throw error
                    })
                    .finally(() => {
                        this.isFetching = false
                    })                

            },  
            
            ocorrenciasFinalizarEfinance(){

                const params = [                    
                    `unidadeId=${this.unidadeId}`,
                    `order=${this.orderOcorrenciasAprovacaoFinanceiro}`                                                      
                ];
                
                this.$http.get(`/api/dashboard/OcorrenciasFinalizarEfinance?${params.join('&')}`)
                        .then(res => res.data)
                        .then(data => {   
                        this.listaOcorrenciasFinalizarEfinance = data;
                    })
                    .catch((error) => {
                        this.listaOcorrenciasFinalizarEfinance = []
                        throw error
                    })
                    .finally(() => {
                        this.isFetching = false
                    })                

            },    
            
            ocorrenciasInstalacoesFuturas(){

                const params = [                    
                    `unidadeId=${this.unidadeId}`,
                    `order=${this.orderOcorrenciasAprovacaoFinanceiro}`                                                      
                ];
                
                this.$http.get(`/api/dashboard/OcorrenciasInstalacoesFuturas?${params.join('&')}`)
                        .then(res => res.data)
                        .then(data => {   
                        this.listaOcorrenciasInstalacoesFuturas = data;
                    })
                    .catch((error) => {
                        this.listaOcorrenciasInstalacoesFuturas = []
                        throw error
                    })
                    .finally(() => {
                        this.isFetching = false
                    })                

            },                
            
            ocorrenciasEntrega(){

                const params = [                    
                    `unidadeId=${this.unidadeId}`,
                    `order=${this.orderOcorrenciasEntrega}`                                                      
                ];
                
                this.$http.get(`/api/dashboard/OcorrenciasEntrega?${params.join('&')}`)
                        .then(res => res.data)
                        .then(data => {   
                        this.listaOcorrenciasEntrega = data;
                    })
                    .catch((error) => {
                        this.listaOcorrenciasEntrega = []
                        throw error
                    })
                    .finally(() => {
                        this.isFetching = false
                    })                

            },             
            
            ocorrenciasParaInstalacao(){

                const params = [                    
                    `unidadeId=${this.unidadeId}`,
                    `order=${this.orderOcorrenciasParaInstalacao}`                                                      
                ];
                
                this.$http.get(`/api/dashboard/OcorrenciasParaInstalacao?${params.join('&')}`)
                        .then(res => res.data)
                        .then(data => {   
                        this.listaOcorrenciasParaInstalacao = data;
                    })
                    .catch((error) => {
                        this.listaOcorrenciasParaInstalacao = []
                        throw error
                    })
                    .finally(() => {
                        this.isFetching = false
                    })                

            },       
            
            
            ocorrenciasEmInstalacao(){

                const params = [                    
                    `unidadeId=${this.unidadeId}`,
                    `order=${this.orderOcorrenciasEmInstalacao}`                                                      
                ];
                
                this.$http.get(`/api/dashboard/OcorrenciasEmInstalacao?${params.join('&')}`)
                        .then(res => res.data)
                        .then(data => {   
                        this.listaOcorrenciasEmInstalacao = data;
                    })
                    .catch((error) => {
                        this.listaOcorrenciasEmInstalacao = []
                        throw error
                    })
                    .finally(() => {
                        this.isFetching = false
                    })                

            },                      
                                 
                                                                                    
            inserirNovaAstec(){
                this.$buefy.modal.open({
                    parent: this,
                    component: modalInserirNovaAstec,
                    events: {
                        loadData: this.loadAsyncData
                    },                                                           
                    hasModalCard: true,
                    trapFocus: true,
                    fullScreen:true
                })
            },            

            retornaEstiloLinha(item){

                if(item.atraso){
                    return 'bg-atraso'
                }else if(item.inside){
                    return 'has-background-dark has-text-white';
                }else{
                    return '';
                }
            },               

            async carregarAstecs(){
                this.loadAsyncData();                              
            },            
            async loadAsyncData() {            
                await this.astecsAbertura(); 
                //await this.astecsAgendamento(); 
                await this.astecsConcluirVisita(); 
                await this.astecsAnaliseVisita(); 
                await this.astecsEmAndamento(); 
                await this.ocorrenciasAnaliseFabrica();  
                await this.ocorrenciasAprovacaoOrcamento();    
                await this.ocorrenciasAprovacaoFinanceiro();
                await this.ocorrenciasEmissao();                                
                await this.ocorrenciasEnvioFabrica();   
                await this.ocorrenciasFinalizarEfinance();
                await this.ocorrenciasInstalacoesFuturas();
                await this.ocorrenciasEntrega();
                await this.ocorrenciasParaInstalacao();                
                await this.ocorrenciasEmInstalacao();                
            },

                                      
            isVendedor(){                
                return this.usuario.nivel == 'Vendedor' || this.usuario.nivel.includes('Vendedor');
            },        
            isConferente(){                
                return this.usuario.nivel == 'Conferente';
            },
            loadTotalNotificacoesFuncionario() {
                
                this.$http.get('/api/notificacao/retornaTotalNotificacoesFuncionario?funcionarioId=' + this.usuario.funcionarioId )
                        .then(res => res.data)
                        .then(data => {   
                        
                        this.$store.commit('componentes/SET_TOTAL_NOTIFICACAO',data)
                    })
                    .catch((error) => {                        
                        throw error
                    });

                this.$http.get('/api/notificacao/RetornaTotalMensagensFuncionario?funcionarioId=' + this.usuario.funcionarioId )
                        .then(res => res.data)
                        .then(data => {   
                        
                            this.$store.commit('componentes/SET_TOTAL_MENSAGENS',data)
                        
                    })
                    .catch((error) => {                        
                        throw error
                    });                      
                
            },                          
                            
        },
        mounted() {                        
            this.loadAsyncData();   
            this.loadTotalNotificacoesFuncionario(); 
            this.verificaPesquisarCliente();      
                                    
        }
    }
</script>